import { Routes } from '@angular/router'
import { MsalGuard } from '@azure/msal-angular'
import { ComponentType_ } from '../shared/services/lookup/[CodeGen]/component-type.domain'
import { ContentShellComponent, CourseLibraryComponent } from './containers'
import { AuthGuardService, CanActivateGuardService } from '@app/shared/services'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

const contentRoutes = SITE_DIRECTORY_ROUTES.content

const childAccountRoutes: Routes = [
   {
      path: '',
      component: CourseLibraryComponent,
      data: {
         componentTypeCode: ComponentType_.CourseLibrary
      }
   }
]

export const CONTENT_ROUTES: Routes = [
   {
      path: contentRoutes.baseUri, /* If not lazy-loading contentRoutes.baseUri, else '' */
      component: ContentShellComponent,
      canActivate: [CanActivateGuardService, MsalGuard, AuthGuardService], /* remove if lazy-loading */
      children: childAccountRoutes
   }
]
